export class Locality {
  constructor(postcode, city, description, coordinates) {
    this.postcode = postcode;
    this.city = city;
    this.description = description;
    this.coordinates = coordinates;
  }
  getDescription() {
    return this.description;
  }
  getLocation() {
    return this.coordinates;
  }
  getPostcode() {
    return this.postcode;
  }
  getCity() {
    return this.city;
  }
}